<ng-template #layoutSelect let-modal>
  <div class="drop-head">
    <h4 class="drop-title" id="modal-basic-title">Choose Layout</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"
      title="Close Modal"></button>
  </div>
  <div class="drop-body">
    <div class="row">
      <div class="col-4">
        <input type="radio" name="select-img-grid" id="layout-1" (click)="onLayoutChange(imageLayoutType.layoutFirst)"
          [checked]="selectedLayout==imageLayoutType.layoutFirst">
        <label for="layout-1" class="form-label">
          <div class="preview-layout-block view-1" ngbAutofocus>
            <img src="./assets/images/grid-view-1.jpg" alt="View">
          </div>
        </label>
      </div>
      <div class="col-4">
        <input type="radio" name="select-img-grid" id="layout-2" (click)="onLayoutChange(imageLayoutType.layoutSecond)"
          [checked]="selectedLayout==imageLayoutType.layoutSecond">
        <label for="layout-2" class="form-label">
          <div class="preview-layout-block view-2">
            <img src="./assets/images/grid-view-2.jpg" alt="View">
          </div>
        </label>
      </div>
      <div class="col-4">
        <input type="radio" name="select-img-grid" id="layout-3" (click)="onLayoutChange(imageLayoutType.layoutThird)"
          [checked]="selectedLayout==imageLayoutType.layoutThird">
        <label for="layout-3" class="form-label">
          <div class="preview-layout-block view-3">
            <img src="./assets/images/grid-view-3.jpg" alt="View">
          </div>
        </label>
      </div>
    </div>
  </div>
</ng-template>